<template>
  <div
    @click="move()"
    :data-pawn-id="player + id"
    :class="($parent.player !== player?'-pe-n':'-z-2')+' -c-p abs -z-1'"
    :style="
      '--transition-time:calc( ' + $parent.game.speed + ' * ' + (this.place === (player + id)? '0.5s':'0.1s') +
      ' );width:calc(var(--unit-case)); height:calc(var(--unit-case));top:' +
      caseTop +
      'px;left:' +
      caseLeft +
      'px;'"
  >
    <div class="u-i >" :style="(('transform: scale(calc( calc(0.6) + calc( 0.4 / '+(position.pawns.length)+' ))) rotate(calc( '+ position.index +' * 360deg / '+position.pawns.length+'));'))">
    <div class="rlt" style="transform: translate(-2px, -12px) scale(0.8)">
      <div
        :class="'b-c c-20-t e -g-b -o-h ' + color"
        style="
          width: calc(var(--unit-case) * 1.2);
          height: calc(var(--unit-case) * 1.2);
          border-radius: 20px 20px 20px 4px;
          transform: rotate(-45deg);
        "
      >
        <transition name="fade">
          <svg v-if="$parent.player === player && Object.values(this.$parent.game.players[this.player].pawns.potentials).includes(this.id.toString()) && this.$parent.step ===2" viewBox="0 0 38 38" class="prgc prg-inf abs u-7">
            <circle cx="50%" cy="50%" r="18" style="stroke-width: 100%;stroke: #fff;/*! stroke-dashoffset: 100px !important; */"></circle>
          </svg>
        </transition>

        <b
          style="
            width: calc(var(--unit-case) * 0.9);
            height: calc(var(--unit-case) * 0.9);
            transform: rotate(45deg);
          "
          :class="'p-2 c-20 ' + color + ' -g-t -b -b-2 -r-c b-c'"
        >
          <!-- {{ position.index }} -->
        </b>
      </div>
      <div class="abs .c-x .b w-5 h-3 -g-t -r-f m-b-3 o-4"></div>
    </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PawnWidget',
  props: {
    id: Number,
    player: String,
    place: String,
    color: String
  },
  data () {
    return {
      caseTop: 0,
      caseLeft: 0,
      canMove: Object.values(this.$parent.game.players[this.player].pawns.potentials).includes(this.id.toString())
    }
  },
  computed: {
    position: function () {
      return this.$parent.getPawnIndexInCase(this.player, this.id, this.place)
    }
  },
  methods: {
    moveToCase (placeId) {
      if (placeId > 52) {
        return
      }
      var _case
      if (!(placeId * 1)) {
        _case = document.querySelector('[data-castle-id="' + this.player + this.id + '"]')
      } else {
        _case = document.querySelector('[data-case-id="' + placeId + '"]')
      }

      // if (!_case) {
      // _case = document.querySelector('[data-case-id="' + placeId - 52 + '"]')
      // }Object.values(this.$parent.game.players[this.player].pawns.potentials).includes(this.id)
      if (_case) {
        var pawnElement = document.querySelector('[data-pawn-id="' + this.player + this.id + '"]')
        this.caseTop = _case.offsetTop
        this.caseLeft = _case.offsetLeft

        pawnElement.classList.add('scl-up')
        setTimeout(() => {
          pawnElement.classList.remove('scl-up')
        }, this.$parent.game.speed * 100)
      }
    },
    moveStepByStep (from, to) {
    },
    move () {
      this.$parent.movePawn(this.id, this.player, this.place)
    }
  },
  watch: {
    place: function (to) {
      this.moveToCase(to)
    }
  },
  mounted () {
    // this.moveToCase(this.$parent.$data.game.players[this.player].start)
    this.moveToCase(this.place)
  }
}
</script>

<style>
[data-pawn-id] {
  transition: all var(--transition-time, 0.1s) ease-out;
}
.scl-up {
  transform:scale(1.3)
}
</style>
